const numMinutes = 10;
export const TRENDS_LOGGING_INTERVAL = numMinutes * 60 * 1000